const Centred = theme => {
  return {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '3rem',
}
}

export default Centred



// WEBPACK FOOTER //
// ./src/styles/mixins/centred.js